import { useI18N } from "@sundae/react-hooks";
import { Notice } from "@sundae/ui-toolkit";
import { FC } from "react";

interface IPriceImpactCheckboxProps {
  handleCheckbox: (isLegalChecked: boolean) => void;
  isLegalChecked: boolean;
  showErrorFlash: boolean;
  context?: string;
}

const PriceImpactCheckbox: FC<IPriceImpactCheckboxProps> = ({
  handleCheckbox,
  isLegalChecked,
  showErrorFlash,
  context,
}) => {
  const { t } = useI18N("exchange");

  return (
    <Notice
      withConsent
      isConsentChecked={isLegalChecked}
      onConsentChange={handleCheckbox}
      showErrorFlash={showErrorFlash}
      title={t("priceImpactWarning", { context: "title" })}
      type="error"
    >
      {t("priceImpactWarning", { context })}
    </Notice>
  );
};

export default PriceImpactCheckbox;
